export const SET_LOGGED_IN = 'SET_LOGGED_IN';
export const SET_ACCOUNT_TYPE = 'SET_ACCOUNT_TYPE';
export const ADMIN = 'ADMIN';
export const USER = 'USER';
export const REDIRECT_TO = 'REDIRECT_TO';
export const SET_LOGIN_ACTION = 'SET_LOGIN_ACTION';
export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_COURSE_DATA = 'SET_COURSE_DATA';
export const SET_USER_COURSES = 'SET_USER_COURSES';